import { OWAConnectedAccount } from 'owa-accounts-store';
import { getUserConfigurationForUser } from 'owa-session-store';
import { initializeOwaConnectedAccountInternal } from './initializeOwaConnectedAccountInternal';

interface InitializeOwaConnectedAccountInfo {
    requestPromise: Promise<void>;
}

const initializeOwaConnectedAccountInfoMap: {
    [userIdentity: string]: InitializeOwaConnectedAccountInfo;
} = {};

/**
 * Adds the account to the `owa-account-store`, fetches the accounts user configuration data/
 * adds it to the session store, and finally dispatches the `owaConnectedAccountAdded` action when
 * this is complete
 * @param account account to be initialized
 */
export async function initializeOwaConnectedAccount(
    account: OWAConnectedAccount,
    isRetry: boolean
): Promise<void> {
    const { userIdentity } = account;
    const userConfiguration = getUserConfigurationForUser(userIdentity);
    const existingRequest = initializeOwaConnectedAccountInfoMap[userIdentity];

    // case 1: the account has already been initialized and data loaded into store, we resolve
    if (userConfiguration && !existingRequest) {
        return Promise.resolve();
    }

    // case 2: there is already a request for the given account, return that promise
    if (existingRequest) {
        return existingRequest.requestPromise;
    }

    // case 3: the initialization needs to process
    const promise = initializeOwaConnectedAccountInternal(account, isRetry);
    initializeOwaConnectedAccountInfoMap[userIdentity] = { requestPromise: promise };
    return promise;
}

export function removeAccountFrominitializeOwaConnectedAccountInfoMap(userIdentity: string) {
    delete initializeOwaConnectedAccountInfoMap[userIdentity];
}
